.fr-obj-collapse {
  border-radius: 4px;
  border: 1px solid #f1f1f1;
  margin-bottom: 24px;
}
.fr-obj-collapse .collapse-title {
  height: 24px;
  color: #000000e0;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.fr-obj-collapse .fr-header-desc {
  word-break: break-all;
  color: rgba(0, 0, 0, 0.45);
  margin-left: 6px;
  font-weight: normal;
}
.fr-obj-collapse .header-item-label {
  height: 14px;
  margin-left: 30px;
  color: black;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}
.fr-obj-collapse .header-item-label span {
  color: #141414;
}
.fr-obj-collapse .expand-icon-desc {
  margin-left: 4px;
}
.fr-obj-collapse .ant-collapse-header {
  display: flex;
  align-items: center !important;
  padding: 16px !important;
  background-color: #fff;
  border-radius: 4px !important;
}
.fr-obj-collapse .ant-collapse-header-text {
  display: flex;
  align-items: center;
}
.fr-obj-collapse .tag-no-data {
  color: rgba(0, 0, 0, 0.65);
}
.fr-obj-collapse .ant-collapse-content-box {
  padding: 12px 24px !important;
}
.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-title,
.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-paragraph > li {
  animation: none !important;
}
